import { reactive } from 'vue';
export const AppStore = reactive({
    currentUser: {},
    realUser: {},
    companyLogo: '',
    defaultPage: 'Dashboard',
    isImpersonating: false,
    navigationItems: [],
    overflowNavigation: [],
    activePage: {},
    activeChildren: [],
    activeSubPage: {},
    loadedFrames: [],
    activeFrameUrl: '',
    isFrameLoading: false,
    shouldShowSidebar: true,
    shouldShowDashboard: false,
    showPageNotImplemented: false,
    setActiveChildren(newChildren) {
        this.activeChildren = newChildren;
    },
    setActivePage(newPage) {
        this.activePage = newPage;
        // Hide the sidebar if the new page only has one child, otherwise use the page's setting
        if (newPage.children.length === 1) {
            this.shouldShowSidebar = false;
        }
        else {
            this.shouldShowSidebar = newPage.shouldShowSidebar;
        }
        // Remember the last sidebar page visited in this category
        if (newPage.lastChildUuid) {
            const child = newPage.children.find(c => c.uuid === newPage.lastChildUuid);
            child?.command();
        }
        else {
            // Open the category home page or default home page
            const defaultPage = getDefaultPage(newPage.children);
            defaultPage?.command();
        }
        this.setActiveChildren(newPage.children);
    },
    setActiveSubPage(newPage) {
        this.activeSubPage = newPage;
        this.setActiveUrl(newPage.url);
        const parentIdx = this.navigationItems.findIndex(item => item.uuid === newPage.parentUuid);
        if (parentIdx === -1)
            return;
        this.navigationItems[parentIdx].lastChildUuid = newPage.uuid;
    },
    setCurrentUser(user) {
        this.currentUser = user;
    },
    setActiveUrl(url) {
        if (this.activeFrameUrl === url)
            return;
        this.activeFrameUrl = url;
        this.isFrameLoading = true;
        if (url === '') {
            this.isFrameLoading = false;
            return;
        }
        const urlIndex = this.loadedFrames.findIndex(item => item.url === url);
        if (urlIndex === -1) {
            this.loadedFrames.push({
                url: url,
                timestamp: new Date(),
                isExpired: false,
            });
        }
        else {
            this.loadedFrames[urlIndex].timestamp = new Date();
            this.loadedFrames[urlIndex].isExpired = false;
            this.isFrameLoading = false;
        }
    },
});
const getDefaultPage = (sidebarItems) => {
    if (!sidebarItems.length)
        return null;
    const explicitHomePage = sidebarItems.find(item => item.isHomePage);
    if (explicitHomePage) {
        return explicitHomePage;
    }
    const defaultHomePage = sidebarItems.find(item => item.isCategoryHome);
    if (defaultHomePage) {
        return defaultHomePage;
    }
    return sidebarItems[0];
};
